import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage, validateYupSchema } from "formik";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import * as Yup from "yup";
import "./DeliveryForm.css"; // Import your CSS file
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import GeneralApiService from "../../services/generalServices";
import { setShowMessage } from "../../redux/slices/notificationSlice";
import { useDispatch } from "react-redux";
import AddRemarks from "./AddRemarks";

// Validation schema with Yup
const DeliveryFormSchema = Yup.object().shape({
  customerName: Yup.string().required("Customer name is required"),
  enquiredDate: Yup.date().required("Enquired date is required"),
  village: Yup.string().required("Village is required"),
  taluka: Yup.string().required("Taluka is required"),
  district: Yup.string().required("District is required"),
  customerMobile: Yup.string().required("Customer mobile number is required"),
  whatsappNumber: Yup.string().required("WhatsApp number is required"),
  deliveryDate: Yup.date().required("Delivery date is required"),
  enquirySource: Yup.string().required("Enquiry Source is required"),
  createdby: Yup.string().required("Created By is required"),
  salesPerson: Yup.string().required("Sales person is required"),
  manufacture: Yup.string().required("Manufacture name is required"),
  modelName: Yup.string().required("Model name is required"),
  paymentMethod: Yup.string().required("Payment method is required"),
  paymentDetail: Yup.string(),
  isOldOwned: Yup.boolean(),
  oldmake: Yup.string().when("isOldOwned", {
    is: true,
    then: (schema) => schema.required("Old Make is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  oldmodel: Yup.string().when("isOldOwned", {
    is: true,
    then: (schema) => schema.required("Old Model is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  oldyear: Yup.string().when("isOldOwned", {
    is: true,
    then: (schema) => schema.required("Old Year is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  oldPrice: Yup.string().when("isOldOwned", {
    is: true,
    then: (schema) => schema.required("Old Price is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  oldCondition: Yup.string().when("isOldOwned", {
    is: true,
    then: (schema) => schema.required("Old Condition is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  newPrice: Yup.string().required("New Price is required"),
  remainingPrice: Yup.string(),
});
const paymentList = [
  { value: "Cash", label: "Cash" },
  { value: "Loan", label: "Loan" },
];

const conditionType = [
  { label: "Good", value: "Good" },
  { label: "Below Average", value: "Below Average" },
  { label: "Average", value: "Average" },
  { label: "Vey Good", value: "Vey Good" },
];

const cashOptions = [
  { label: "Rokda (In-Hand)", value: "rokda" },
  { label: "Check", value: "check" },
];
const EditFollowUpStageForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { ev_stage, editData } = location?.state;
  const [banklist, setBankList] = useState([]);
  const [modelslistByAgencyMake, setModelslistByAgencyMake] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [remarks, setRemarks] = useState({
    discussion: "",
    nextDate: "",
    isRemark: false,
  });
  const [filterModelList, setFilterModelList] = useState([]);
  const [newFilterModelList, setNewFilterModelList] = useState([]);
  const [customerData, setCustomerData] = useState({});
  const [makeList, setMakeList] = useState([]);
  const [dspList, setDspList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [talukaList, setTalukaList] = useState([]);
  const [filterdTalukaList, setfilterdTalukaList] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [filteredVillageList, setFileredVillageList] = useState([]);
  const [enquirySourceList, setEnqirySourceList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [initialValues, setInitialValues] = useState({
    customerName: "",
    enquiredDate: null,
    village: "",
    taluka: "",
    district: "",
    customerMobile: "",
    whatsappNumber: "",
    deliveryDate: null,
    enquirySource: "",
    createdby: "",
    salesPerson: "",
    manufacture: "",
    modelName: "",
    paymentMethod: "Cash",
    paymentDetail: "",
    isOldOwned: false,
    oldmake: "",
    oldmodel: "",
    oldyear: "",
    oldCondition: "",
    newPrice: "",
    oldPrice: "",
    remainingPrice: "",
  });

  const fetchBankList = async () => {
    try {
      const url = `${process.env.REACT_APP_NODE_URL}/api/get-bank-list`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };

      const response = await axios.get(url, config);

      if (response.data?.isSuccess) {
        setBankList(
          response.data.result.map((item) => ({
            value: item.bankname,
            label: item.bankname,
          }))
        );
      } else {
        console.error("API request was not successful");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchCustomerDetails = async (customerId) => {
    try {
      const url = `${process.env.REACT_APP_NODE_URL}/api/general/get-customerData/${customerId}`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };

      const response = await axios.get(url, config);

      if (response.data?.isSuccess) {
        const [rowData] = response.data.result.customerData;
        setCustomerData(rowData);
      } else {
        console.error("API request was not successful");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getVehicleMakeModels = async () => {
    const url = `${process.env.REACT_APP_NODE_URL}/api/master/get-make-modal-list`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };

    try {
      const response = await axios.get(url, config);
      if (response && response.data) {
        const {
          makeList,
          modelList,
          modelslistByAgencyMake,
          dspList,
          enquirySourceList,
          districtList,
          talukaList,
          villageList,
        } = response.data.result;
        setMakeList(
          makeList.map((item) => ({ value: item.id, label: item.name }))
        );
        setModelList(modelList);
        setModelslistByAgencyMake(
          modelslistByAgencyMake.map((item) => ({
            value: item.id,
            label: item.modalName,
          }))
        );
        setDspList(dspList);
        setEnqirySourceList(enquirySourceList);
        setDistrictList(districtList);
        setTalukaList(talukaList);
        setVillageList(villageList);
      } else {
        setMakeList([]);
        setModelList([]);
        setModelslistByAgencyMake([]);
        setDspList([]);
        setEnqirySourceList([]);
        setDistrictList([]);
        setTalukaList([]);
        setVillageList([]);
      }
    } catch (error) {
      console.error("Error fetching getVehicleMakeModels:", error);
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  };
  useEffect(() => {
    if (editData && editData.id) {
      fetchCustomerDetails(editData.id);
    }
  }, [editData]);
  useEffect(() => {
    getVehicleMakeModels();
    fetchBankList();
  }, []);

  useEffect(() => {
    console.log(editData, customerData, "---------");
    if (!loading && editData && customerData) {
      setInitialValues({
        customerName: customerData.customerName,
        enquiredDate: editData.enquiry_date
          ? moment(editData.enquiry_date).format("YYYY-MM-DD")
          : "",
        village: customerData.village,
        taluka: customerData.taluka,
        district: customerData.district,
        customerMobile: editData.phone_number,
        whatsappNumber: editData.whatsapp_number,
        deliveryDate: editData.delivery_date
          ? moment(editData.delivery_date).format("YYYY-MM-DD")
          : "",
        enquirySource: customerData.enquiry_source_id,
        createdby: customerData.user_created,
        salesPerson: customerData.salesperson_id,
        manufacture: customerData.manufacture,
        modelName: customerData.modal_id,
        paymentMethod: customerData.paymentMode,
        paymentDetail: customerData.paymentDetails ?? "",
        isOldOwned: customerData.old_tractor === "Yes",
        oldmake: customerData.oldmake,
        oldmodel: customerData.oldmodel,
        oldyear: customerData.oldyear,
        oldCondition: customerData.oldCondition,
        newPrice: (customerData.newPrice ?? 0).toString(),
        oldPrice: (customerData.oldPrice ?? 0).toString(),
        remainingPrice: (customerData.remainingPrice ?? 0).toString(),
      });

      setfilterdTalukaList(
        talukaList.filter((val) => val.district_id == customerData.district)
      );
      setFileredVillageList(
        villageList.filter((val) => val.taluka_id == customerData.taluka)
      );

      // New Modelist
      const NewFiltered = modelList
        .filter((model) => model.manufacturerId == customerData.manufacture)
        .map((val) => ({ value: val.id, label: val.modalName }));

      setNewFilterModelList(NewFiltered);

      // Old Modelist
      const filtered = modelList
        .filter((model) => model.manufacturerId == customerData.oldmake)
        .map((val) => ({ value: val.id, label: val.modalName }));

      setFilterModelList(filtered);
    }
  }, [loading, editData, customerData]);

  const formatRupee = (value) => {
    // Ensure the value has a rupee symbol and only numeric characters after it
    return value.replace(/[^\d]/g, ""); // Keep only numbers
  };

  const years = Array.from({ length: 2024 - 1970 + 1 }, (_, i) => {
    const year = (1970 + i).toString();
    return { value: year, label: year };
  });

  const formatType = (type) =>
    type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();

  const onSubmitRemark = (remark) => {
    setRemarks(remark);
  };

  const handleSubmit = (values) => {
    const processedValues = {
      ...values,
      newPrice: parseInt(values.newPrice.replace(/\s/g, "")) || 0,
      oldPrice: parseInt(values.oldPrice.replace(/\s/g, "")) || 0,
      remainingPrice:
        parseInt(values.remainingPrice.replace(/\s/g, "")) || 0,
    };

    try {
      processedValues["editType"] = ev_stage.type;
      processedValues["remarks"] = remarks;
      processedValues["customerId"] = editData.id;
      console.log("Processed Form Data:", processedValues);
      const EditRequest = new GeneralApiService();
      EditRequest.editEnquiryStageRequest(processedValues).then((response) => {
        if (response && response.success) {
          const formattedType = formatType(ev_stage.type);
          navigate(`/sale/enquiries/${formattedType}`, {
            state: { type: ev_stage.type },
          });
          dispatch(setShowMessage(response.message));
        }
      });
    } catch (error) {
      console.log(error, "Error submitting form");
    }
  };

  return (
    <Container className="bg-white rounded">
      <Row className="justify-content-md-center">
        <Col md={12}>
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={DeliveryFormSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, values, touched, errors, setFieldValue }) => {
              const calculateRemainingPrice = () => {
                const newPrice =
                  parseInt(values.newPrice.replace(/[^\d]/g, ""), 10) || 0;
                const oldPrice =
                  parseInt(values.oldPrice.replace(/[^\d]/g, ""), 10) || 0;
                const remainingPrice = Math.max(newPrice - oldPrice, 0);
                setFieldValue(
                  "remainingPrice",
                  formatRupee(remainingPrice.toString())
                );
              };
              const onDistrictChange = (e) => {
                const selectedDistrict = e.target.value;
                setFieldValue("district", selectedDistrict);
                setfilterdTalukaList(
                  talukaList.filter(
                    (val) => val.district_id == selectedDistrict
                  )
                );
              };

              const onTalukaChange = (e) => {
                const selectedTaluka = e.target.value;
                setFieldValue("taluka", selectedTaluka);
                setFileredVillageList(
                  villageList.filter((val) => val.taluka_id == selectedTaluka)
                );
              };
              const onMakeChange = (e, type) => {
                const selectedMake = e.target.value;
                if (type === "New") {
                  setFieldValue("manufacture", selectedMake);
                  const filtered = modelList
                    .filter((model) => model.manufacturerId == selectedMake)
                    .map((val) => ({ value: val.id, label: val.modalName }));

                  setNewFilterModelList(filtered);
                } else {
                  setFieldValue("oldmake", selectedMake);
                  const filtered = modelList
                    .filter((model) => model.manufacturerId == selectedMake)
                    .map((val) => ({ value: val.id, label: val.modalName }));

                  setFilterModelList(filtered);
                }
              };
              return (
                <Form>
                  <Row className="mb-1">
                    <Col md={12}>
                      <div className="d-flex align-items-center justify-content-between">
                        <label className="m-0 form-label">
                          EDIT{" "}
                          {ev_stage.type.charAt(0).toUpperCase() +
                            ev_stage.type.slice(1)}
                        </label>

                        <Button
                          variant="outline-secondary"
                          className="text-muted mt-1"
                          size="small"
                          onClick={() => {
                            navigate(-1);
                          }}
                        >
                          BACK
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={12} className="mb-1">
                      <h5 className="m-0 form-label">Basic Details</h5>
                    </Col>
                    <Col md={4}>
                      <label htmlFor="customerName" className="form-label">
                        Name
                      </label>
                      <Field
                        name="customerName"
                        className="form-control"
                        type="text"
                      />
                      <ErrorMessage
                        name="customerName"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="customerMobile" className="form-label">
                        Phone Number
                      </label>
                      <Field
                        name="customerMobile"
                        className="form-control"
                        type="phone"
                      />
                      <ErrorMessage
                        name="customerMobile"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="whatsappNumber" className="form-label">
                        WhatsApp Number
                      </label>
                      <Field
                        name="whatsappNumber"
                        className="form-control"
                        type="phone"
                      />
                      <ErrorMessage
                        name="whatsappNumber"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={4}>
                      <label htmlFor="district" className="form-label">
                        District
                      </label>
                      <Field
                        as="select"
                        name="district"
                        className="form-control"
                        onChange={(e) => onDistrictChange(e)}
                      >
                        <option value="" label="Select District" />
                        {districtList.map((dist) => (
                          <option
                            key={dist.value}
                            value={dist.value}
                            label={dist.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="district"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>

                    <Col md={4}>
                      <label htmlFor="taluka" className="form-label">
                        Taluka
                      </label>
                      <Field
                        as="select"
                        name="taluka"
                        className="form-control"
                        onChange={(e) => onTalukaChange(e)}
                      >
                        <option value="" label="Select Taluka" />
                        {filterdTalukaList.map((taluka) => (
                          <option
                            key={taluka.value}
                            value={taluka.value}
                            label={taluka.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="taluka"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>

                    <Col md={4}>
                      <label htmlFor="village" className="form-label">
                        Village
                      </label>
                      <Field
                        as="select"
                        name="village"
                        className="form-control"
                      >
                        <option value="" label="Select Village" />
                        {filteredVillageList.map((village) => (
                          <option
                            key={village.value}
                            value={village.value}
                            label={village.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="village"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={4}>
                      <label htmlFor="enquiredDate" className="form-label">
                        Enquiry Date
                      </label>
                      <Field
                        name="enquiredDate"
                        className="form-control"
                        type="date"
                      />
                      <ErrorMessage
                        name="enquiredDate"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>

                    <Col md={4}>
                      <label htmlFor="deliveryDate" className="form-label">
                        Expected Delivery Date
                      </label>
                      <Field
                        name="deliveryDate"
                        className="form-control"
                        type="date"
                      />
                      <ErrorMessage
                        name="deliveryDate"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>

                    <Col md={4}>
                      <label htmlFor="enquirySource" className="form-label">
                        Enquiry Source
                      </label>
                      <Field
                        as="select"
                        name="enquirySource"
                        className="form-control"
                      >
                        <option value="" label="Select Enquiry Source" />
                        {enquirySourceList.map((eos) => (
                          <option
                            key={eos.value}
                            value={eos.value}
                            label={eos.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="enquirySource"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={4}>
                      <label htmlFor="salesPerson" className="form-label">
                        Sales Person
                      </label>
                      <Field
                        as="select"
                        name="salesPerson"
                        className="form-control"
                      >
                        <option value="" label="Select Sales Person" />
                        {dspList.map((dsp) => (
                          <option
                            key={dsp.value}
                            value={dsp.value}
                            label={dsp.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="salesPerson"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="createdby" className="form-label">
                        Enquiry Ad
                      </label>
                      <Field
                        as="select"
                        name="createdby"
                        className="form-control"
                      >
                        <option value="" label="Select Enquiry Ad" />
                        {dspList.map((dsp) => (
                          <option
                            key={dsp.value}
                            value={dsp.value}
                            label={dsp.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="createdby"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={12} className="mb-1">
                      <h5 className="m-0 form-label">Product Details</h5>
                    </Col>
                    <Col md={4}>
                      <label htmlFor="manufacture" className="form-label">
                        Manufacture Name
                      </label>
                      <Field
                        as="select"
                        name="manufacture"
                        className="form-control"
                        onChange={(e) => onMakeChange(e, "New")}
                      >
                        <option value="" label="Select Manufacture Name" />
                        {makeList.map((make) => (
                          <option
                            key={make.value}
                            value={make.value}
                            label={make.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="manufacture"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="modelName" className="form-label">
                        Model Name
                      </label>
                      <Field
                        as="select"
                        name="modelName"
                        className="form-control"
                      >
                        <option value="" label="Select Model" />
                        {newFilterModelList.map((model) => (
                          <option
                            key={model.value}
                            value={model.value}
                            label={model.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="modelName"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="newPrice" className="form-label">
                        New Tractor Price
                      </label>
                      <Field
                        name="newPrice"
                        className="form-control"
                        type="text"
                        onBlur={() => {
                          calculateRemainingPrice();
                        }}
                        placeholder="0"
                      />
                      <ErrorMessage
                        name="newPrice"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                  </Row>
                  {/* Checkbox for Is Old Owned */}
                  <Row className="mb-2">
                    <Col md={12}>
                      <label className="form-check-label">
                        <Field
                          type="checkbox"
                          name="isOldOwned"
                          className="form-check-input"
                        />{" "}
                        Is Old Owned?
                      </label>
                    </Col>
                  </Row>
                  {values.isOldOwned && (
                    <Row className="mb-3">
                      <Col md={4} className="mb-3">
                        <label htmlFor="oldmake" className="form-label">
                          Make
                        </label>
                        <Field
                          as="select"
                          name="oldmake"
                          className="form-control"
                          onChange={(e) => onMakeChange(e, "old")}
                        >
                          <option value="" label="Select make" />
                          {makeList.map((make) => (
                            <option
                              key={make.value}
                              value={make.value}
                              label={make.label}
                            />
                          ))}
                        </Field>
                        <ErrorMessage
                          name="oldmake"
                          component={({ children }) => (
                            <span
                              style={{ color: "darkred", fontSize: "0.875rem" }}
                            >
                              {children}
                            </span>
                          )}
                        />
                      </Col>
                      <Col md={4} className="mb-3">
                        <label htmlFor="oldmodel" className="form-label">
                          Model
                        </label>
                        <Field
                          as="select"
                          name="oldmodel"
                          className="form-control"
                        >
                          <option value="" label="Select model" />
                          {filterModelList.map((model) => (
                            <option
                              key={model.value}
                              value={model.value}
                              label={model.label}
                            />
                          ))}
                        </Field>
                        <ErrorMessage
                          name="oldmodel"
                          component={({ children }) => (
                            <span
                              style={{ color: "darkred", fontSize: "0.875rem" }}
                            >
                              {children}
                            </span>
                          )}
                        />
                      </Col>
                      <Col md={4} className="mb-3">
                        <label htmlFor="oldyear" className="form-label">
                          Year
                        </label>
                        <Field
                          as="select"
                          name="oldyear"
                          className="form-control"
                        >
                          <option value="" label="Select year" />
                          {years.map((year) => (
                            <option
                              key={year.value}
                              value={year.value}
                              label={year.label}
                            />
                          ))}
                        </Field>
                        <ErrorMessage
                          name="oldyear"
                          component={({ children }) => (
                            <span
                              style={{ color: "darkred", fontSize: "0.875rem" }}
                            >
                              {children}
                            </span>
                          )}
                        />
                      </Col>
                      <Col md={4}>
                        <label htmlFor="oldPrice" className="form-label">
                          Old Tractor Price
                        </label>
                        <Field
                          name="oldPrice"
                          className="form-control"
                          type="text"
                          onBlur={() => {
                            calculateRemainingPrice();
                          }}
                          placeholder="0"
                        />
                        <ErrorMessage
                          name="oldPrice"
                          component={({ children }) => (
                            <span
                              style={{ color: "darkred", fontSize: "0.875rem" }}
                            >
                              {children}
                            </span>
                          )}
                        />
                      </Col>
                      <Col md={4}>
                        <label htmlFor="oldCondition" className="form-label">
                          Condition
                        </label>
                        <Field
                          as="select"
                          name="oldCondition"
                          className="form-control"
                        >
                          <option value="" label="Select condition" />
                          {conditionType.map((type) => (
                            <option
                              key={type.value}
                              value={type.value}
                              label={type.label}
                            />
                          ))}
                        </Field>
                        <ErrorMessage
                          name="oldCondition"
                          component={({ children }) => (
                            <span
                              style={{ color: "darkred", fontSize: "0.875rem" }}
                            >
                              {children}
                            </span>
                          )}
                        />
                      </Col>
                    </Row>
                  )}
                  <Row className="mb-3">
                    <Col md={4}>
                      <label htmlFor="remainingPrice" className="form-label">
                        Remaining Price
                      </label>
                      <Field
                        name="remainingPrice"
                        className="form-control"
                        type="text"
                        placeholder="0"
                        readOnly
                      />
                      <ErrorMessage
                        name="remainingPrice"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="paymentMethod" className="form-label">
                        Payment Method
                      </label>
                      <Field
                        as="select"
                        name="paymentMethod"
                        className="form-control"
                      >
                        <option value="" label="Select Payment Method" />
                        {paymentList.map((payment) => (
                          <option
                            key={payment.value}
                            value={payment.value}
                            label={payment.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="paymentMethod"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    {values["paymentMethod"] === "Cash" && (
                      <Col md={4}>
                        <label htmlFor="paymentDetail" className="form-label">
                          Payment Details
                        </label>
                        <Field
                          as="select"
                          name="paymentDetail"
                          className="form-control"
                        >
                          <option value="" label={`Select Payment Details`} />
                          {cashOptions.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="paymentDetail"
                          component={({ children }) => (
                            <span
                              style={{ color: "darkred", fontSize: "0.875rem" }}
                            >
                              {children}
                            </span>
                          )}
                        />
                      </Col>
                    )}
                    {values["paymentMethod"] === "Loan" && (
                      <Col md={4}>
                        <label htmlFor="paymentDetail" className="form-label">
                          Payment Details
                        </label>
                        <Field
                          as="select"
                          name="paymentDetail"
                          className="form-control"
                        >
                          <option value="" label={`Select Payment Details`} />
                          {banklist.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="paymentDetail"
                          component={({ children }) => (
                            <span
                              style={{ color: "darkred", fontSize: "0.875rem" }}
                            >
                              {children}
                            </span>
                          )}
                        />
                      </Col>
                    )}
                  </Row>

                  <AddRemarks onSubmitRemark={onSubmitRemark} />

                  {/* Save Changes */}
                  <Row className="mb-2">
                    <Col md={12}>
                      <Button
                        variant="outline-primary"
                        className="px-5"
                        type="submit"
                        // disabled={isSubmitting}
                      >
                        Save Changes
                      </Button>

                      <Button
                        variant="outline-primary"
                        className=" ms-2 px-4"
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Form>
              );
            }}
          </Formik>
        </Col>
      </Row>
    </Container>
  );
};

export default EditFollowUpStageForm;
